import { UserRoleE } from "../../../models/enums";

/**
 * Whether the current user may create a new media company from the campaign wizard's
 * "Media Company" field — the "+" icon next to the label and the in-dropdown "create new" entry.
 *
 * Mirrors the backend authorisation on `Clients/UserPostMediaCompany`
 * (`AdvertisingAgencyNonGuest` + `DeliveryService` + `GlobalAdminAndAdminContentManager`): a
 * media-company user is the one role that must not create media companies — they cannot reassign
 * the campaign's media company either, which is why that field is read-only for them.
 *
 * A media company's **delivery-service** user resolves to `UserRoleE.DeliveryService`, not
 * `UserRoleE.MediaCompany` (`getUserRole.ts` checks `AccessLevel` before the client type), so
 * delivery-service users keep the action — as do advertising agencies. Unchanged by design.
 *
 * Shared by both campaign wizards so the two cannot drift apart.
 */
export const canCreateMediaCompany = (role?: UserRoleE) =>
  role !== UserRoleE.MediaCompany;
